import { FC } from "react";
import RegistrationForm from "./RegistrationForm";
import PageTemplate from "../PageTemplate";

const Registration: FC = () => {
    return <PageTemplate Page={RegistrationForm} />;
};

export default Registration;
